import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { PaymentDomain } from "checkout-query-client/api/types";

import { GooglePayButton } from "./google-pay-button";

interface GooglePayProps {
  paymentDomain?: PaymentDomain;
  isDisabled?: boolean;
}

export const GooglePay = ({
  paymentDomain,
  isDisabled = false,
}: GooglePayProps) => {
  const { t } = useTranslation(["combined"]);
  return (
    <>
      <Text styleVariant="caption" colorVariant="primaryText">
        {t("googlePay.messageReviewLine1")}
      </Text>
      <GooglePayButton paymentDomain={paymentDomain} isDisabled={isDisabled} />
    </>
  );
};
